<div class="modal-header">
    <h4 class="modal-title">{{ dialogHeader }}</h4>
</div>
<div class="modal-body" (keyup.esc)="cancel()" (keyup.enter)="enterPressed()">
    <div class="mb-2" *ngIf="dialogPrompt">{{ dialogPrompt }}</div>
    <div *ngIf="mode === 'text'">
        <dx-text-box #inputComponent [(value)]="dialogValue" valueChangeEvent="input"></dx-text-box>
    </div>
    <div *ngIf="mode === 'date'">
        <dx-date-box #inputComponent [(value)]="dialogValue" valueChangeEvent="input"></dx-date-box>
    </div>
    <div *ngIf="mode === 'password'">
        <dx-text-box #inputComponent [(value)]="dialogValue" [mode]="'password'" valueChangeEvent="input" (onInput)="onInput($event)"></dx-text-box>
    </div>
    <div *ngIf="mode === 'textarea'">
        <dx-text-area #inputComponent [(value)]="dialogValue" [height]="300"></dx-text-area>
    </div>
    <div *ngIf="mode === 'select'">
        <dx-select-box #inputComponent [(value)]="dialogValue" [items]="dialogValueArray"></dx-select-box>
    </div>
    <div *ngIf="mode === 'selectWithId'">
        <dx-select-box #inputComponent [(value)]="dialogValue" [items]="dialogValueArray" [valueExpr]="'id'" [displayExpr]="'name'" ></dx-select-box>
    </div>
    <div class="mt-3" *ngIf="!!dialogMessage">
        {{ dialogMessage }}
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="save(true)" [hidden]="!saveAndNewVisible">Save & New</button>
    <button type="button" class="btn btn-success" (click)="save()">Save</button>
    <button type="button" class="btn btn-light" (click)="cancel()">Cancel</button>
</div>
